import { FC, SVGProps } from "react";

import Confused from "@/assets/illustrations/confused.svg";
// OLD
import ConfusedGrey from "@/assets/illustrations/confused-grey.svg";
// NEW
import Container from "@/assets/illustrations/container.svg";
import ContainerDark from "@/assets/illustrations/container-dark.svg";
import Delivery from "@/assets/illustrations/delivery.svg";
import DeliveryDark from "@/assets/illustrations/delivery-dark.svg";
import FlowerQr from "@/assets/illustrations/flower-qr.svg";
import FlowerQrDark from "@/assets/illustrations/flower-qr-dark.svg";
import Laundry from "@/assets/illustrations/laundry.svg";
import LaundryDark from "@/assets/illustrations/laundry-dark.svg";
import Person from "@/assets/illustrations/person.svg";
import PersonGrey from "@/assets/illustrations/personGrey.svg";
import Vines from "@/assets/illustrations/vines.svg";
import WindowLaptop from "@/assets/illustrations/window-laptop.svg";
import WindowLaptopDark from "@/assets/illustrations/window-laptop-dark.svg";
import World from "@/assets/illustrations/world.svg";
import WorldGreenBg from "@/assets/illustrations/world-green.svg";

import { IllustrationProps, IllustrationType } from "./index";

// AVAIALABLE ILLUSTRATIONS
export const availableIllustrations: Record<
  IllustrationType,
  FC<SVGProps<SVGSVGElement>>
> = {
  // OLD
  confused: Confused,
  confusedGrey: ConfusedGrey,
  person: Person,
  personGrey: PersonGrey,
  vines: Vines,
  world: World,
  worldGreenBg: WorldGreenBg,
  // NEW
  container: Container,
  containerDark: ContainerDark,
  delivery: Delivery,
  deliveryDark: DeliveryDark,
  flowerQr: FlowerQr,
  flowerQrDark: FlowerQrDark,
  laundry: Laundry,
  laundryDark: LaundryDark,
  windowLaptop: WindowLaptop,
  windowLaptopDark: WindowLaptopDark,
};

const Illustration = ({
  type,
  title,
  illustrationClassName,
  illustrationStyle = {},
}: IllustrationProps) => {
  const SVG = availableIllustrations[type];
  return (
    <SVG
      className={illustrationClassName}
      style={illustrationStyle}
      aria-label={title}
    />
  );
};

export default Illustration;
